<!-- Pinned Module Shortcuts -->
@if (pinnedService.hasVisiblePins()) {
  <div class="flex items-center gap-sm">
    @for (pin of uniqueVisiblePins(); track pin.moduleKey) {
      <div class="relative inline-flex">
        <button
          type="button"
          (click)="onPinClick($event, pin.moduleKey, pinPopover)"
          class="group relative grid place-items-center h-8 w-8 rounded-full text-white shadow-sm
                 hover:brightness-105 transition-all duration-200 cursor-pointer"
          [style.background]="getModule(pin.moduleKey)?.color || '#6b7280'"
          [matTooltip]="getModuleLabel(pin.moduleKey)"
          matTooltipPosition="below"
          [attr.aria-haspopup]="'menu'"
          [attr.aria-expanded]="openMenuModuleKey() === pin.moduleKey"
          [attr.aria-label]="getModuleLabel(pin.moduleKey)"
        >
          @if (getModule(pin.moduleKey)?.icon) {
            <app-module-icon
              [iconName]="getModule(pin.moduleKey)!.icon"
              [width]="12"
              [height]="12"
              [white]="true"
            ></app-module-icon>
          }
        </button>

        <app-popover
          #pinPopover
          appendTo="body"
          direction="center"
          styleClass="table-action-popover pinned-module-menu"
          (onHide)="onPinPopoverHide(pin.moduleKey)"
        >
          <div class="custom-actions-menu min-w-[180px] rounded-xl overflow-hidden">
            <ul class="list-none p-0 m-0 flex flex-col gap-0.5">
              @for (screen of getModuleScreens(pin.moduleKey); track screen.key) {
                <li
                  class="group px-3 py-1.5 rounded-lg transition-colors text-sm font-normal text-light-text flex items-center gap-3 hover:bg-gray-50 hover:text-primary cursor-pointer"
                  (click)="onScreenSelect(screen, pinPopover)"
                >
                  {{ screen.translationKey | translate }}
                </li>
              }
            </ul>
          </div>
        </app-popover>
      </div>
    }

    <!-- Divider -->
    <div class="w-px h-6 bg-line mx-1"></div>
  </div>
}
